const getStart = (text, lowerIndex) => {
    if (lowerIndex === 0) { 
        return ''
    } else {
        return '...'
    }
}

export default getStart;
